module.exports = __webpack_public_path__ + "static/MonumentExtended-Regular-3cf29d3474ec4292f4b979241aa3f9b2.woff";